export default __webpack_public_path__ + "static/media/loader.6fcabdc5.svg";